const $ = window.jQuery;
import Splide from "@splidejs/splide";
$(function () {
	let carousel_and_text = document.querySelectorAll(".carousel_and_text .splide");
	if (carousel_and_text.length > 0) {
		for (let i = 0; i < carousel_and_text.length; i++) {
			let carouselElement = carousel_and_text[i];
			let carouselDefaultOptions = {
				type: "slide",
				arrows: false,
				pagination: false,
				drag: 'free',
				gap: '30px',
				autoWidth: true
			};
			let carousel = new Splide(carouselElement, carouselDefaultOptions);
			carousel.mount();
		}
	}
});
